// extracted by mini-css-extract-plugin
export default {"container":"IFrameWrapper_container__UsfQd"};